import {
  DEFAULT_PUCK_ACCESS_LEVEL,
  normalizePuckAccessLevel,
  type PuckAccessLevel,
} from "@/lib/cms-puck/blocks/page-access";
import { Label } from "@/components/ui/label";
import {  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";

export function PageAccessField({
  value,
  onChange,
}: {
  value: PuckAccessLevel | undefined;
  onChange: (value: PuckAccessLevel) => void;
}) {
  const cmsNew = useCmsNew();
  const current = normalizePuckAccessLevel(value ?? DEFAULT_PUCK_ACCESS_LEVEL);

  return (
    <div className="space-y-3">
      <div className="space-y-2">
        <Label htmlFor="page-access-level">{cmsNew("cms.new.auto.text.niveau_d_apos_acces", "Niveau d&apos;accès")}</Label>
        <Select
          value={current}
          onValueChange={(next) => onChange(normalizePuckAccessLevel(next))}
        >
          <SelectTrigger id="page-access-level">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="public">{cmsNew("cms.new.auto.text.public", "Public")}</SelectItem>
            <SelectItem value="subscribed">{cmsNew("cms.new.auto.text.abonnement_requis", "Abonnement requis")}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <p className="text-xs leading-relaxed text-slate-500">
        {cmsNew(
          "cms.new.fields.pageAccess.hint",
          "Les visiteurs non connectés sont redirigés vers la connexion. Ceux sans abonnement actif sont redirigés vers la page d'abonnement. Pensez à republier la page après modification.",
        )}
      </p>
    </div>
  );
}
